module.exports = __webpack_public_path__ + "static/media/Emmanuel Onyeje - Backbase.b0777cb3.jpg";